<template>
    <div class="companyList">
      <company-list-container></company-list-container>
    </div>
</template>
<script>
import CompanyListContainer from '@/components/companylist/Container.vue'
export default {
  name: 'companylist',
  components: {
    CompanyListContainer
  }
}
</script>
<style lang="stylus">
.companyList
  height 100%
</style>
